<app-section
  titleSection="Photographies"
  [isActivated]="photographies.isEnabled"
  (enabled)="onEnabled($event)"
  (cancled)="onCancled()"
>
  <div read-mode class="px-3">
    <app-photographies-read-mode [photographies]="photographiesInternal">
    </app-photographies-read-mode>
  </div>

  <div edit-mode>
    <app-photographies-edit-mode
      [photographies]="photographiesInternal"
      [reportId]="reportId"
      (photographiesChanged)="photographiesSectionChanged($event)"
      (removePhoto)="onClearPhoto($event)"
    >
    </app-photographies-edit-mode>
  </div>

  <div save-button>
    <p-button
      id="btn-valider-section"
      label="Valider"
      level="primary"
      title="Valider"
      [loading]="isLoading"
      [disabled]="isLoading"
      (click)="onSaveSection()"
    ></p-button>
  </div>
</app-section>
